/* Any core Frappe Web Form (frappe/website/doctype/web_form/templates/
 * web_form.html - Address edit/new, and any other Web Form doctype on the
 * site) sits outside any [data-rfhq-theme] scope, same root cause already
 * diagnosed and fixed for the filter sidebar, /shop-by-category, PDP, and
 * Cart. Genuinely broken, not just unthemed: .control-label has no colour
 * rule anywhere in core CSS at all (relies purely on inheritance), so once
 * <body> itself became a themed ancestor (rfhq_body_theme.js) every label
 * on a still-white .web-form-header/.web-form box started inheriting
 * body's light text colour onto a still-literal-white background - found
 * live on /addresses: rgb(255,255,255) text on rgb(255,255,255) bg.
 * Same fix: claim it data-rfhq-owned and hand it to the existing
 * site-theme fallback; CSS pass gives labels/inputs their own explicit
 * colour rather than leaving them to inherit at all.
 */

frappe.ready(function () {
	var el = document.querySelector('.web-form-container');
	if (!el) return; // not this page

	el.setAttribute('data-rfhq-owned', '1');
	if (window.rfhqApplyOwnedThemeFallback) window.rfhqApplyOwnedThemeFallback(el);
});
